import { render, staticRenderFns } from "./lczj.vue?vue&type=template&id=52bd7e4b"
import script from "./lczj.vue?vue&type=script&lang=js"
export * from "./lczj.vue?vue&type=script&lang=js"
import style0 from "./lczj.vue?vue&type=style&index=0&id=52bd7e4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports